module.exports = __webpack_public_path__ + "img/Pilz.e31cc423.jpg";